export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration-by-phone-confirmation.vue?vue&type=template&id=045c02e6"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/registration-by-phone-confirmation.vue?vue&type=template&id=045c02e6
// module id = oPKZ
// module chunks = 0